import PatientHeader from './_PatientHeader';

export default PatientHeader;
